export default "__VITE_ASSET__C7a9vkHX__"